<template>
    <li class="hierarchy-node">
        <div class="hierarchy-item" :class="{ 'active': item.id === currentCompanyId }">
            <i class="fa fa-briefcase mr-1"></i>
            <span class="hierarchy-name">{{ item.name }}</span>
            <a
                v-if="item.is_leaf && item.id !== currentCompanyId && !switching"
                class="hierarchy-switch-link ml-auto"
                href="#"
                @click.prevent.stop="onSwitch"
            >
                <i class="fa fa-arrow-right ml-1 mr-1"></i>View As
            </a>
            <span v-if="switching" class="hierarchy-switch-link ml-auto text-muted" style="opacity:1;">
                <i class="fa fa-cog fa-spin ml-1 mr-05"></i>Switching...
            </span>
        </div>
        <ul v-if="item.children && item.children.length" class="hierarchy-children">
            <hierarchy-node
                v-for="child in item.children"
                :key="child.id"
                :item="child"
                :current-company-id="currentCompanyId"
                @switch-to="$emit('switch-to', $event)"
            ></hierarchy-node>
        </ul>
    </li>
</template>

<script>
export default {
    name: 'HierarchyNode',
    props: ['item', 'currentCompanyId'],
    emits: ['switch-to'],
    data() {
        return {
            switching: false
        }
    },
    methods: {
        onSwitch() {
            this.switching = true;
            this.$emit('switch-to', this.item);
        }
    }
}
</script>
